export default __webpack_public_path__ + "static/media/261.27258d93.jpg";